export enum CustomerPSRSubmissionDataTest {
  SUMMARY_CONTAINER_OPTED_IN = "SUMMARY_CONTAINER_OPTED_IN",
  SUMMARY_CONTAINER_OPTED_OUT = "SUMMARY_CONTAINER_OPTED_OUT",
  ERROR_CONTAINER = "ERROR_CONTAINER",
  SUMMARY_CONTAINER_NOT_ELIGIBLE = "SUMMARY_CONTAINER_NOT_ELIGIBLE",
}
